import { useDispatch, useSelector } from "react-redux";
import { RootState, ThunkDispatch } from "core-integration/src/store";
import { getAllStatsForFixture } from "core-integration/src/store/fixtures/reducers";
import { useEffect } from "react";
import { fetchFixtureAllStats } from "core-integration/src/store/fixtures/thunks";
import { IGroupFixture } from "core-integration/src/store/fixtures/types";
import { PlayerStatsTableWrapper } from "./table";

interface PlayerStats {
  fixture: IGroupFixture;
}

const PlayerStats = ({ fixture }: PlayerStats) => {
  const dispatch = useDispatch<ThunkDispatch>();
  const allStatsForFixture = useSelector((state: RootState) =>
    getAllStatsForFixture(state, fixture.id),
  );

  useEffect(() => {
    if (!allStatsForFixture) {
      dispatch(fetchFixtureAllStats(fixture.id));
    }
  }, [fixture, dispatch, allStatsForFixture]);

  const stats = allStatsForFixture
    ? allStatsForFixture.h
        .concat(allStatsForFixture.a)
        .sort((a, b) => b.total_points - a.total_points)
    : [];

  return <PlayerStatsTableWrapper fixture={fixture} stats={stats} />;
};

export default PlayerStats;
